import React from 'react';
import Styles from './investment-positions.scss';
import { CircleLoader } from '@/presentation/components';
import { ExpenseItem } from '@/presentation/components/expenses-modal/expnse-item/expnse-item';
import { formatAccountBalance } from '@/presentation/utils/money-utils';
import Chart from '../chart/chart';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
const InvestmentPositions = ({ chartHeight, chartWidth, items, total, loading }) => {
    return (React.createElement("div", { className: Styles.expensesModal },
        React.createElement("h3", { className: Styles.title }, "Investment by positions"),
        React.createElement("br", null),
        React.createElement("div", { className: Styles.chartContainer },
            loading ? (React.createElement("div", { style: {
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                } },
                React.createElement(CircleLoader, null))) : (React.createElement(Chart, { items: items, width: chartWidth, height: chartHeight, title: {
                    title: 'Total Spending',
                    amount: `${formatAccountBalance(total)} KV`
                } })),
            React.createElement("div", { className: Styles.data }, loading ? (React.createElement(SkeletonTheme, { baseColor: "rgba(242,244,248,0.8)", highlightColor: "rgba(227, 227, 228, 0.8)", borderRadius: "0.5rem", duration: 4 }, new Array(8).fill('#').map((item, index) => (React.createElement(Skeleton, { key: `${index}-${item}`, width: 200, height: 40, style: { marginBottom: '0.5rem', placeSelf: 'center', alignSelf: 'center' } }))))) : (React.createElement(React.Fragment, null, items
                .filter(i => i.title !== 'EMPTY')
                .map((item, index) => (React.createElement(ExpenseItem, { key: index, item: {
                    title: item.title,
                    color: item.color,
                    percentage: `${item.value}`,
                    amount: item.amount,
                    value: Number(item.value)
                } })))))))));
};
export default InvestmentPositions;
